/** Standard currency formatter — always shows cents. Historically this
 *  rounded to the dollar; Exco + Finance wanted true precision on shipped
 *  / WIP / invoicing figures, so cents are the default everywhere. Use
 *  `fmtCurrencyWhole` on the rare call-site that wants no-cents display. */
export function fmtCurrency(n: number): string {
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Back-compat alias — some call sites imported this explicitly. Now that
 *  `fmtCurrency` defaults to cents, this just forwards. */
export const fmtCurrencyCents = fmtCurrency;

/** No-cents formatter for the rare place that wants $123 instead of $123.00. */
export function fmtCurrencyWhole(n: number): string {
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}

export function fmtHours(n: number): string {
  return `${parseFloat(n.toFixed(1))}h`;
}

export function fmtMonth(yyyyMm: string): string {
  const [y, m] = yyyyMm.split('-');
  return new Date(parseInt(y), parseInt(m) - 1, 1).toLocaleString('en-US', {
    month: 'short',
    year: 'numeric',
  });
}

export function fmtPct(n: number): string {
  return `${(n * 100).toFixed(1)}%`;
}

/** Locale date-time that degrades gracefully: shows the raw string rather than
 *  "Invalid Date" if it can't be parsed, and an em dash for null/empty. */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}

export function currentMonth(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
